import * as R from 'ramda';
import React from 'react';
import { mapProps } from 'recompose';
import { connect } from 'react-redux';

import Modal from '../components/modal';
import { modalNames } from './constants';
import { TasksModal } from './tasks-modal';
import { BudgetModal } from './budget-modal';
import { LoadingModal } from './loading-modal';
import { CommentsModal } from './comments-modal';
import { EditRequestModal } from './edit-request';
import { EditContactModal } from './edit-contact';
import { EditCompanyModal } from './edit-company';
import { closeCurrentModal } from './modal-reducer';
import { ChangeStatusModal } from './change-status';
import { NextActionModal } from './next-action-modal';
import { AssignUserModal } from './assign-user-modal';
import { AddNewRequestModal } from './add-new-request';
import { AddNewContactModal } from './add-new-contact';
import { AddNewCompanyModal } from './add-new-company';
import { RequestDetailsModal } from './request-details';
import { ManageUsersModal } from './manage-users-modal';
import { ManageEmailsModal } from './manage-emails-modal';
import { MeetingNotesModal } from './meeting-notes-modal';
import { ManageTalentsModal } from './manage-talents-modal';
import { AddMeetingNotesModal } from './add-meeting-notes-modal';
import { OrganizationSettingsModal } from './organization-settings-modal';


const modals = {
  [modalNames.TASKS]: TasksModal,
  [modalNames.BUDGET]: BudgetModal,
  [modalNames.LOADING]: LoadingModal,
  [modalNames.COMMENTS]: CommentsModal,
  [modalNames.ASSIGN_USER]: AssignUserModal,
  [modalNames.NEXT_ACTION]: NextActionModal,
  [modalNames.EDIT_REQUEST]: EditRequestModal,
  [modalNames.EDIT_CONTACT]: EditContactModal,
  [modalNames.EDIT_COMPANY]: EditCompanyModal,
  [modalNames.MANAGE_USERS]: ManageUsersModal,
  [modalNames.MANAGE_EMAILS]: ManageEmailsModal,
  [modalNames.MEETING_NOTES]: MeetingNotesModal,
  [modalNames.CHANGE_STATUS]: ChangeStatusModal,
  [modalNames.ADD_NEW_REQUEST]: AddNewRequestModal,
  [modalNames.ADD_NEW_CONTACT]: AddNewContactModal,
  [modalNames.ADD_NEW_COMPANY]: AddNewCompanyModal,
  [modalNames.REQUEST_DETAILS]: RequestDetailsModal,
  [modalNames.ADD_MEETING_NOTES]: AddMeetingNotesModal,
  [modalNames.MANAGE_REQUEST_TALENTS]: ManageTalentsModal,
  [modalNames.ORGANIZATION_SETTINGS]: OrganizationSettingsModal,
  empty: () => null,
};

const ModalWindow = R.compose(
  connect(
    R.prop('modal'),
    { closeCurrentModal },
  ),
  mapProps(({
    name, payload, width, simple, isCloseIconOuter, style, ...actions
  }) => {
    const ActiveModal = modals[name] || modals.empty;
    return {
      width,
      style,
      simple,
      isOpen: !!name,
      isCloseIconOuter,
      children: <ActiveModal payload={payload} />,
      onClose: () => actions.closeCurrentModal(),
    };
  }),
)(Modal);

export default ModalWindow;



// WEBPACK FOOTER //
// ./src/modals/modal-window.js